// extracted by mini-css-extract-plugin
export default {"component":"ErrorMessage_component__JrN5v","lightIcon":"ErrorMessage_lightIcon__z6bk3","darkIcon":"ErrorMessage_darkIcon__INaXj"};